/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPersonRiskGroupRequest } from '../models/AddPersonRiskGroupRequest';
import type { AddPersonRiskGroupResponse } from '../models/AddPersonRiskGroupResponse';
import type { EndPersonRiskGroupRequest } from '../models/EndPersonRiskGroupRequest';
import type { GetPersonRiskGroupClassifierResponse } from '../models/GetPersonRiskGroupClassifierResponse';
import type { GetPersonRiskGroupsResponse } from '../models/GetPersonRiskGroupsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PersonRiskGroupService {
    /**
     * Endpoint to get person risk groups
     * This endpoint requires the following permissions: [  ]
     * @param personId
     * @param pageNumber
     * @param pageSize
     * @returns GetPersonRiskGroupsResponse Success
     * @throws ApiError
     */
    public static getPersonRiskGroupsEndpoint(
        personId: string,
        pageNumber?: number | null,
        pageSize?: number | null,
    ): CancelablePromise<GetPersonRiskGroupsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{personId}/risk-groups',
            path: {
                'personId': personId,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Endpoint to get person risk group classifier for person
     * This endpoint requires the following permissions: [  ]
     * @param personId Person identifier.
     * @param startDate Start date of risk group.
     * @returns GetPersonRiskGroupClassifierResponse Success
     * @throws ApiError
     */
    public static getPersonRiskGroupClassifierEndpoint(
        personId: string,
        startDate?: string | null,
    ): CancelablePromise<GetPersonRiskGroupClassifierResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{personId}/risk-group-classifiers',
            path: {
                'personId': personId,
            },
            query: {
                'startDate': startDate,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Update EndDate for person active risk group
     * This endpoint requires the following permissions: [ Persons.RiskGroups.Add.Institution ]
     * @param personId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static endPersonRiskGroupEndpoint(
        personId: string,
        requestBody: EndPersonRiskGroupRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons/{personId}/risk-group/end',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Update EndDate for person active risk group
     * This endpoint requires the following permissions: [ Persons.RiskGroups.Remove.Institution ]
     * @param personId
     * @param personRiskGroupId
     * @returns void
     * @throws ApiError
     */
    public static deletePersonRiskGroupEndpoint(
        personId: string,
        personRiskGroupId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/persons/{personId}/risk-group/{personRiskGroupId}',
            path: {
                'personId': personId,
                'personRiskGroupId': personRiskGroupId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Add Risk group to person
     * This endpoint requires the following permissions: [ Persons.RiskGroups.Add.Institution ]
     * @param personId
     * @param requestBody
     * @returns AddPersonRiskGroupResponse Success
     * @throws ApiError
     */
    public static addPersonRiskGroupEndpoint(
        personId: string,
        requestBody: AddPersonRiskGroupRequest,
    ): CancelablePromise<AddPersonRiskGroupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons/{personId}/risk-group',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
}
